import { render, staticRenderFns } from "./DiceJigsaw.vue?vue&type=template&id=f25c4ee0"
import script from "./DiceJigsaw.vue?vue&type=script&lang=js"
export * from "./DiceJigsaw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports